import { Typography } from '@mui/material'
import React, { useEffect } from 'react'

import { GAME_FACT_BASKET_STOP, reasonListBasketStop } from '../constants.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapBasketStop = ({state, match, inHistory}) => {
    const {timer, comment, title, period, reason = 'next'} = state

    const [img] = useGameFact({type : GAME_FACT_BASKET_STOP})

    const actualPeriod =  period ??  match.period
  
    return (
      <div style={{color : inHistory ? 'black' : 'white'}}>
        <img src={img} width={150}/>
        <Typography>Titre : {title}</Typography>
        <Typography>Commentaire : {comment}</Typography>
        <Typography>A venir : {reasonListBasketStop.find(r => r.id === reason) && reasonListBasketStop.find(r => r.id === reason).value}</Typography>
        {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
      </div>
    )
  }

export default RecapBasketStop